// extracted by mini-css-extract-plugin
module.exports = {"minHieght60":"MarkExamSubjectModal_minHieght60_3nRYQ"};